export { default } from './my-avatar';
